/* eslint-disable max-len */
const React = require('react');
const { Black, Default, White, Gray } = require('./Images/Colors');
const { MCO, MLA, MLB, MLC, MLM, MLU, MPE } = require('./Images/Countries');
const { Master, Visa, Amex, Naranja, Maestro, Cabal, Cencosud, Cordobesa, Argencard, Diners, Tarshop, CMR, Rapipago, Pagofacil } = require('./Images/PaymentMethods');

function componentProps(i18n, lang) {
  return {
    title: i18n.gettext('Brand Brick'),
    description: i18n.gettext('Construye y comprueba la experiencia visual en tiempo real. Cuando esté todo listo, descarga o copia el código generado para agregarlo a tu sitio web o compartirlo con un desarrollador.'),
    breadCrumbLevels: [
      {
        text: i18n.gettext('Documentación'),
        id: '1',
        href: `/developers/${lang}/docs`,
      },
      {
        text: i18n.gettext('Checkout Bricks'),
        id: '2',
        href: `/developers/${lang}/docs/checkout-bricks/landing`,
      },
      {
        text: i18n.gettext('Brand Brick'),
        id: '3',
        href: `/developers/${lang}/docs/checkout-bricks/brand-brick/introduction`,
      },
      {
        text: i18n.gettext('Demostración'),
        id: '4',
        disabled: true,
      },
    ],
    publicKey: 'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b',
    optionsDescription: i18n.gettext('Configuración básica'),
    mobileDescription: i18n.gettext('Ingresa a la Demostración en una computadora para hacer configuraciones más avanzadas y tener acceso al código generado.'),
    languages: [
      {
        description: i18n.gettext('Português'),
        value: 'pt-BR',
      },
      {
        description: i18n.gettext('Español'),
        value: 'es-AR',
      },
      {
        description: i18n.gettext('English'),
        value: 'en-US',
      },
    ],
    options: [
      {
        id: 'publicKey',
        type: 'dropdown',
        label: i18n.gettext('Selecciona el país de operación'),
        placeholder: i18n.gettext('País de operación'),
        trackingLabel: 'COUNTRY_OF_OPERATION',
        defaultValue: 'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b',
        items: [
          { value: 'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b', primary: i18n.gettext('Argentina'), icon: <MLA />, siteId: 'MLA' },
          { value: 'TEST-de563cac-2acb-4ec6-b506-9fb302a2848d', primary: i18n.gettext('Brasil'), icon: <MLB />, siteId: 'MLB' },
          { value: 'TEST-852eef7f-952a-43ca-887f-19780ecf8ed8', primary: i18n.gettext('México'), icon: <MLM />, siteId: 'MLM' },
          { value: 'TEST-7094fa90-db4e-4dc1-82ed-54072977aae5', primary: i18n.gettext('Uruguay'), icon: <MLU />, siteId: 'MLU' },
          { value: 'TEST-af696d89-c335-4cc1-982c-af28f38e7894', primary: i18n.gettext('Colombia'), icon: <MCO />, siteId: 'MCO' },
          { value: 'TEST-36ac5e4f-11ca-4152-93fa-1e90d870ad13', primary: i18n.gettext('Chile'), icon: <MLC />, siteId: 'MLC' },
          { value: 'TEST-513b4541-d1e6-419b-9cf2-23dc290669ad', primary: i18n.gettext('Perú'), icon: <MPE />, siteId: 'MPE' },
        ],
        width: 'full',
        hide: true,
      },
      {
        id: 'valueProp',
        type: 'dropdown',
        label: i18n.gettext('Propuesta de valor'),
        placeholder: i18n.gettext('Propuesta de valor (encabezado del banner)'),
        trackingLabel: 'VALUE_PROP',
        defaultValue: 'payment_methods',
        items: [
          { value: 'payment_methods', primary: i18n.gettext('Medios de pago con texto') },
          { value: 'payment_methods_logos', primary: i18n.gettext('Medios de pago con texto y logos') },
          { value: 'installments', primary: i18n.gettext('Cuotas con tarjeta de crédito') },
          { value: 'credits', primary: i18n.gettext('Hasta 12 cuotas sin tarjeta') },
          { value: 'security', primary: i18n.gettext('Seguridad') },
        ],
        width: 'full',
      },
      {
        id: 'paymentTypes',
        type: 'dropdownMulti',
        label: i18n.gettext('Medios de pago'),
        defaultValue: ['credit_card', 'debit_card', 'ticket'],
        trackingLabel: 'PAYMENT_TYPES',
        items: [
          { value: 'credit_card', primary: i18n.gettext('Tarjeta de crédito') },
          { value: 'debit_card', primary: i18n.gettext('Tarjeta de débito') },
          { value: 'ticket', primary: i18n.gettext('Efectivo') },
        ],
        conditionalRender: [
          {
            inputId: 'valueProp',
            expectedValue: ['payment_methods', 'payment_methods_logos'],
          },
        ],
        width: 'full',
      },
      {
        id: 'paymentMethods',
        type: 'dropdownMulti',
        label: i18n.gettext('Banderas'),
        defaultValue: ['master', 'visa', 'amex', 'naranja', 'maestro', 'cabal', 'cencosud', 'cordobesa', 'argencard', 'diners', 'tarshop', 'cmr', 'rapipago', 'pagofacil'],
        trackingLabel: 'PAYMENT_METHODS',
        items: [
          { value: 'master', primary: i18n.gettext('Mastercard'), icon: <Master /> },
          { value: 'visa', primary: i18n.gettext('Visa'), icon: <Visa /> },
          { value: 'amex', primary: i18n.gettext('American Express'), icon: <Amex /> },
          { value: 'naranja', primary: 'Naranja X', icon: <Naranja /> },
          { value: 'maestro', primary: i18n.gettext('Maestro'), icon: <Maestro /> },
          { value: 'cabal', primary: i18n.gettext('Cabal'), icon: <Cabal /> },
          { value: 'cencosud', primary: i18n.gettext('Cencosud'), icon: <Cencosud /> },
          { value: 'cordobesa', primary: i18n.gettext('Cordobesa'), icon: <Cordobesa /> },
          { value: 'argencard', primary: i18n.gettext('Argencard'), icon: <Argencard /> },
          { value: 'diners', primary: i18n.gettext('Diners'), icon: <Diners /> },
          { value: 'tarshop', primary: i18n.gettext('Tarjeta Shopping'), icon: <Tarshop /> },
          { value: 'cmr', primary: i18n.gettext('CMR'), icon: <CMR /> },
          { value: 'rapipago', primary: i18n.gettext('Rapipago'), icon: <Rapipago /> },
          { value: 'pagofacil', primary: i18n.gettext('Pago Fácil'), icon: <Pagofacil /> },
        ],
        width: 'full',
        conditionalRender: [
          {
            inputId: 'valueProp',
            expectedValue: ['installments', 'payment_methods', 'payment_methods_logos'],
          },
        ],
      },
      {
        id: 'maxInstallments',
        type: 'dropdown',
        label: i18n.gettext('Número máximo de cuotas'),
        placeholder: i18n.gettext('Número máximo de cuotas'),
        message: i18n.gettext('Válido solo para pagos con tarjeta de crédito'),
        trackingLabel: 'MAX_INSTALLMENTS',
        defaultValue: 12,
        width: 'full',
        items: [
          { value: 2, primary: `2 ${i18n.gettext('cuotas')}` },
          { value: 3, primary: `3 ${i18n.gettext('cuotas')}` },
          { value: 4, primary: `4 ${i18n.gettext('cuotas')}` },
          { value: 5, primary: `5 ${i18n.gettext('cuotas')}` },
          { value: 6, primary: `6 ${i18n.gettext('cuotas')}` },
          { value: 7, primary: `7 ${i18n.gettext('cuotas')}` },
          { value: 8, primary: `8 ${i18n.gettext('cuotas')}` },
          { value: 9, primary: `9 ${i18n.gettext('cuotas')}` },
          { value: 10, primary: `10 ${i18n.gettext('cuotas')}` },
          { value: 11, primary: `11 ${i18n.gettext('cuotas')}` },
          { value: 12, primary: `12 ${i18n.gettext('cuotas')}` },
        ],
        conditionalRender: [
          {
            inputId: 'valueProp',
            expectedValue: ['installments', 'payment_methods', 'payment_methods_logos'],
          },
        ],
      },
      {
        id: 'interestFreeInstallments',
        type: 'switch',
        trackingLabel: 'INTEREST_FEE_INSTALLMENTS',
        label: i18n.gettext('Cuotas sin interés'),
        width: 'full',
        defaultValue: false,
        checked: true,
        conditionalRender: [
          {
            inputId: 'valueProp',
            expectedValue: ['installments', 'payment_methods', 'payment_methods_logos'],
          },
        ],
      },
      {
        id: 'changesMessage',
        type: 'message',
        title: i18n.gettext('Importante'),
        children: i18n.gettext('El banner comunica la propuesta de valor en general. "Saber más" abre un pop-up con más detalles.'),
        messageType: 'info',
        hierarchy: 'quiet',
        width: 'full',
        conditionalRender: [
          {
            inputId: 'valueProp',
            expectedValue: ['installments', 'credits', 'payment_methods', 'payment_methods_logos'],
          },
        ],
      },
    ],
    advancedOptionsDescription: i18n.gettext('Configuraciones avanzadas'),
    advancedOptions: [
      {
        id: 'showMercadoPagoLogo',
        type: 'switch',
        trackingLabel: 'SHOW_MERCADO_PAGO_COLOR',
        label: i18n.gettext('Mostrar el logo de Mercado Pago'),
        width: 'full',
        defaultValue: true,
        checked: true,
      },
      {
        id: 'labelFont',
        type: 'title',
        title: i18n.gettext('Fuente'),
        width: 100,
      },
      {
        id: 'useCustomFont',
        type: 'switch',
        trackingLabel: 'USE_CUSTOM_FONT',
        label: i18n.gettext('Usar fuente personalizada'),
        width: 'full',
        defaultValue: false,
        checked: true,
        tooltipContent: i18n.gettext('Al habilitar esta opción, tu diseño va a tener la tipografía de tu sitio.'),
      },
      {
        id: 'size',
        type: 'dropdown',
        label: i18n.gettext('Tamaño'),
        placeholder: i18n.gettext('Tamaño'),
        trackingLabel: 'TEXT_SIZE',
        defaultValue: 'medium',
        items: [
          { value: 'extra_small', primary: i18n.gettext('Extra Small') },
          { value: 'small', primary: i18n.gettext('Small') },
          { value: 'medium', primary: i18n.gettext('Medium') },
          { value: 'large', primary: i18n.gettext('Large') },
        ],
        width: 'full',
      },
      {
        id: 'fontWeight',
        type: 'dropdown',
        label: i18n.gettext('Peso'),
        placeholder: i18n.gettext('Peso'),
        trackingLabel: 'TEXT_SIZE',
        defaultValue: 'semibold',
        items: [
          { value: 'regular', primary: i18n.gettext('Regular') },
          { value: 'semibold', primary: i18n.gettext('Semibold') },
        ],
        width: 'full',
      },
      {
        id: 'labelFont',
        type: 'title',
        title: i18n.gettext('Alineación'),
        width: 100,
      },
      {
        id: 'align',
        type: 'dropdown',
        label: i18n.gettext('Texto'),
        placeholder: i18n.gettext('Texto'),
        trackingLabel: 'ALIGN',
        defaultValue: 'left',
        items: [
          { value: 'left', primary: i18n.gettext('Left') },
          { value: 'center', primary: i18n.gettext('Center') },
          { value: 'right', primary: i18n.gettext('Right') },
        ],
        width: 'full',
        conditionalRender: [
          {
            inputId: 'valueProp',
            expectedValue: ['security', 'installments', 'credits', 'payment_methods'],
          },
        ],
      },
      {
        id: 'contentAlign',
        type: 'dropdown',
        label: i18n.gettext('Texto y logos'),
        placeholder: i18n.gettext('Texto y logos'),
        trackingLabel: 'CONTENT_ALIGN',
        defaultValue: 'center',
        items: [
          { value: 'left', primary: i18n.gettext('Left') },
          { value: 'center', primary: i18n.gettext('Center') },
          { value: 'right', primary: i18n.gettext('Right') },
        ],
        width: 'full',
        conditionalRender: [
          {
            inputId: 'valueProp',
            expectedValue: ['payment_methods_logos'],
          },
        ],
      },
      {
        id: 'verticalPadding',
        type: 'slider',
        label: i18n.gettext('Padding vertical'),
        defaultValue: 8,
        trackingLabel: 'VERTICAL_PADDING',
        minValue: 0,
        maxValue: 40,
        width: 'full',
      },
      {
        id: 'horizontalPadding',
        type: 'slider',
        label: i18n.gettext('Padding horizontal'),
        defaultValue: 16,
        trackingLabel: 'HORIZONTAL_PADDING',
        minValue: 0,
        maxValue: 48,
        width: 'full',
      },
      {
        id: 'labelColors',
        type: 'title',
        title: i18n.gettext('Colores'),
        width: 100,
      },
      {
        id: 'color',
        type: 'dropdown',
        label: i18n.gettext('Texto'),
        placeholder: i18n.gettext('Texto'),
        trackingLabel: 'COLOR',
        defaultValue: 'secondary',
        items: [
          { value: 'primary', primary: i18n.gettext('Primary'), icon: <Black /> },
          { value: 'secondary', primary: i18n.gettext('Secondary'), icon: <Gray /> },
          { value: 'inverted', primary: i18n.gettext('Inverted'), icon: <White /> },
        ],
        width: 'full',
      },
      {
        id: 'backgroundColor',
        type: 'dropdown',
        label: i18n.gettext('Fondo'),
        placeholder: i18n.gettext('Fondo'),
        trackingLabel: 'BACKGROUND_COLOR',
        defaultValue: 'white',
        items: [
          { value: 'white', primary: i18n.gettext('White'), icon: <White /> },
          { value: 'black', primary: i18n.gettext('Black'), icon: <Black /> },
          { value: 'transparent', primary: i18n.gettext('Transparent'), icon: <White /> },
          { value: 'mercado_pago_primary', primary: i18n.gettext('Mercado Pago Primary'), icon: <Default /> },
        ],
        width: 'full',
      },
      {
        id: 'labelBorder',
        type: 'title',
        title: i18n.gettext('Borde'),
        width: 100,
      },
      {
        id: 'border',
        type: 'switch',
        trackingLabel: 'BORDER',
        label: i18n.gettext('Mostrar borde'),
        width: 'full',
        defaultValue: false,
        checked: true,
      },
      {
        id: 'borderColor',
        type: 'dropdown',
        label: i18n.gettext('Color'),
        placeholder: i18n.gettext('Color'),
        trackingLabel: 'BORDER_COLOR',
        defaultValue: 'dark',
        items: [
          { value: 'dark', primary: i18n.gettext('Dark'), icon: <Black /> },
          { value: 'light', primary: i18n.gettext('Light'), icon: <White /> },
        ],
        width: 'full',
        conditionalRender: [
          {
            inputId: 'border',
            expectedValue: true,
          },
        ],
      },
      {
        id: 'borderRadius',
        type: 'slider',
        label: i18n.gettext('Radio'),
        defaultValue: 0,
        trackingLabel: 'BORDER_RADIUS',
        minValue: 0,
        maxValue: 24,
        width: 'full',
        conditionalRender: [
          {
            inputId: 'border',
            expectedValue: true,
          },
        ],
      },
      {
        id: 'borderWidth',
        type: 'slider',
        label: i18n.gettext('Ancho'),
        defaultValue: 1,
        trackingLabel: 'BORDER_WIDTH',
        minValue: 1,
        maxValue: 2,
        width: 'full',
        conditionalRender: [
          {
            inputId: 'border',
            expectedValue: true,
          },
        ],
      },
    ],
  };
}

function getProps(i18n, lang) {
  return componentProps(i18n, lang);
}

module.exports = { getProps };
